// extracted by mini-css-extract-plugin
module.exports = {"component":"why-module--component--15DAX","group":"why-module--group--1TIIV","expander":"why-module--expander--bs9ah","expanderButton":"why-module--expanderButton--28Umf"};